import { Text } from '@lego/klik-ui';
import type { ReactNode } from 'react';

type Props = { children: ReactNode };

export const PlaceholderText = ({ children }: Props) => <Text color="slate.500">{children}</Text>;
